module.exports = __webpack_public_path__ + "img/mortuary.a63d4162.svg";